import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import apiInstance from "../../../services/ServiceApi";

function Pagos({ open, handleClose, identificador, id_linea_negocio, cuenta_cliente }) {
  const [data, setData] = useState([]);
  
  useEffect(() => {
    if(open) {
      apiInstance.post('/pagos/', {
        identificador,
        cuenta_cliente,
        id_linea_negocio
      }).then(response => {
        setData(response.data);
      }).catch(error => {
        console.error(error);
      });
    }
  }, [open, identificador, id_linea_negocio, cuenta_cliente]);
  
  const getTableHeaders = () => {
    if(data.length > 0) {
      return Object.keys(data[0]).map(key => 
        <TableCell key={key} style={{ textTransform: "uppercase", padding: '16px' }}>
          {key.replace(/-/g, " ")}
        </TableCell>
      );
    }
    return null;
  };
  
  return (
    <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="md">
      <DialogTitle style={{ position: 'relative' }}>
        Pagos Realizados
        <IconButton style={{ position: 'absolute', right: 0, top: 0 }} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TableContainer component={Paper} style={{ margin: '20px' }}>
          <Table>
            <TableHead>
              <TableRow>
                {getTableHeaders()}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index} style={{ backgroundColor: index % 2 === 0 ? '#f7f7f7' : 'white' }}>
                  {Object.values(row).map((value, i) => (
                    <TableCell key={i}>{value}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
}

export default Pagos;
